import { useDisplayTimezone } from 'src/contexts/DisplayTimezoneProvider';

/**
 * Hook to access the current display timezone value.
 *
 * This hook returns only the timezone string.
 * For access to both the value and setter, use `useDisplayTimezone` from `src/contexts/DisplayTimezoneProvider`.
 *
 * @returns The current display timezone string (never null/undefined, defaults to local timezone)
 *
 * @example
 * ```tsx
 * const displayTimezone = useDisplayTimezoneValue();
 * console.log(displayTimezone); // e.g., 'America/Los_Angeles'
 * ```
 */
const useDisplayTimezoneValue = (): string => {
  const [displayTimezone] = useDisplayTimezone();
  return displayTimezone;
};

export default useDisplayTimezoneValue;
